import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'login',
  component: login
},
]

const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   next()
//   // 在这里执行你的拦截逻辑
//   let user = window.sessionStorage.getItem('token')
//   // 检查用户是否已登录
//   if (!user) {
//     // 如果未登录，则重定向到登录页
//     next('/')
//   } else {
//     // 如果已登录，则继续路由切换
//     next()
//   }
// })

export default router